import { render, staticRenderFns } from "./ProjectEvaluationList.vue?vue&type=template&id=06fb0188&scoped=true"
import script from "./ProjectEvaluationList.vue?vue&type=script&lang=js"
export * from "./ProjectEvaluationList.vue?vue&type=script&lang=js"
import style0 from "./ProjectEvaluationList.vue?vue&type=style&index=0&id=06fb0188&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb0188",
  null
  
)

export default component.exports